import { Union } from 'ts-toolbelt';

export const notEmpty = <I>(arr?: Union.Nullable<I[]>): true | undefined => {
  return arr && arr.length ? true : undefined;
};
